
const base_url = "../assets/images"

export const mainLogo = require("../assets/images/logo/logo.png")
export const mainTitle = "Conklin PhysioChiro+"
// export const bannerServiceImage  = require('../assets/images/main-bg-services.jpg')
// export const bannerSpecImage  = require('../assets/images/main-spec-bg.jpg')
// export const bannerTestinomialImage = require("../assets/images/testenomial_main_bg.jpg")
// export const bannerTestinomialDetailImage = require("../assets/images/testinomial_detail_bg.jpg")
// export const contactusBanner = require("../assets/images/contactus_banner.jpg")
// export const appointmentMain = require("../assets/images/appointment-main.jpg")
// export const blogBanner = require("../assets/images/blog_banner.jpg")
// export const patientBanner = require("../assets/images/patientform_main_bg.jpg")
// export const bannerImage  = require(`../assets/images/main-bg.png`)


export const blogOne = {
    imageOne:require(`../assets/images/blog/1b/blogPhysio-1.jpg`),
    imageTwo:require(`../assets/images/blog/1b/blogPhysio-2.jpg`),
    imageThree:require(`../assets/images/blog/1b/blogPhysio-3.jpg`),
}

export const blogTwo = {
    imageOne:require(`../assets/images/blog/2b/blogChiro-1.jpg`),
    imageTwo:require(`../assets/images/blog/2b/blogChiro-2.jpg`),
    imageThree:require(`../assets/images/blog/2b/blogChiro-3.jpg`),
}

export const blogThree = {
    imageOne:require(`../assets/images/blog/3b/blogMassage-1.jpg`),
    imageTwo:require(`../assets/images/blog/3b/blogMassage-2.jpg`),
    imageThree:require(`../assets/images/blog/3b/blogMassage-3.jpg`),
}

export const blogFour = {
    imageOne:require(`../assets/images/blog/4b/blogMobility-1.jpg`),
    imageTwo:require(`../assets/images/blog/4b/blogMobility-2.jpg`),
    imageThree:require(`../assets/images/blog/4b/blogMobility-3.jpg`),
}

export const blogFive = {
    imageOne:require(`../assets/images/blog/5b/blogBetter-1.jpg`),
    imageTwo:require(`../assets/images/blog/5b/blogBetter-2.jpg`),
    imageThree:require(`../assets/images/blog/5b/blogBetter-3.jpg`),
}


export const homeBanners = {
    bannerOne:require(`../assets/images/main/homeBanner/homeBanner-1.png`),
    bannerTwo:require(`../assets/images/main/homeBanner/homeBanner-2.jpg`),
    bannerThree:require(`../assets/images/main/homeBanner/homeBanner-3.jpg`),
}

export const serviceBanners = {
    bannerOne:require(`../assets/images/main/serviceBanner/serviceBanner-1.jpg`),
    bannerTwo:require(`../assets/images/main/serviceBanner/serviceBanner-2.jpg`),
    bannerThree:require(`../assets/images/main/serviceBanner/serviceBanner-3.jpg`),
}

export const specBanners = {
    bannerOne:require(`../assets/images/main/specBanner/spec_banner-1.jpg`),
    bannerTwo:require(`../assets/images/main/specBanner/spec_banner-2.jpg`),
    bannerThree:require(`../assets/images/main/specBanner/spec_banner-3.jpg`),
}

export const contactBanners = {
    bannerOne:require(`../assets/images/main/contactBanner/contactusBanner-1.jpg`),
    bannerTwo:require(`../assets/images/main/contactBanner/contactusBanenr-2.jpg`),
    bannerThree:require(`../assets/images/main/contactBanner/contactusBanner-3.jpg`),
}

export const aboutBanners = {
    bannerOne:require(`../assets/images/main/aboutBanner/aboutusBanner-1.jpg`),
    bannerTwo:require(`../assets/images/main/aboutBanner/aboutusBanner-2.jpg`),
    bannerThree:require(`../assets/images/main/aboutBanner/aboutusBanner-3.jpg`),
}

export const blogBanners = {
    bannerOne:require(`../assets/images/main/blogBanner/blogBanner-1.jpg`),
    bannerTwo:require(`../assets/images/main/blogBanner/blogBanner-2.jpg`),
    bannerThree:require(`../assets/images/main/blogBanner/blogBanner-3.jpg`),
}



export const doctorHomeImages = {
    doctor1:require(`../assets/images/doctor/doctor-1.jpg`),
    doctor2:require(`../assets/images/doctor/doctor-2.jpg`),
    doctor3:require(`../assets/images/doctor/doctor-3.jpg`),
    doctor4:require(`../assets/images/doctor/doctor-4.jpg`),
    doctor5:require(`../assets/images/doctor/doctor-5.jpg`),
    doctor6:require(`../assets/images/doctor/doctor-6.jpg`)
}

export const servicesImages = {
    arthritis:require(`../assets/images/services/arthiritis/arthiritis.jpg`),
    arthritisOne:require(`../assets/images/services/arthiritis/arthritis-1.jpg`),
    arthritisTwo:require(`../assets/images/services/arthiritis/arthritis-2.jpg`),
    balancetraining:require(`../assets/images/services/balanceTraining/balancetraining.jpg`),
    balancetrainingOne:require(`../assets/images/services/balanceTraining/balanceTraining-1.jpg`),
    balancetrainingTwo:require(`../assets/images/services/balanceTraining/balanceTraining-2.jpg`),
    gaittraining:require(`../assets/images/services/gaitTraining/gaittraining.jpg`),
    gaittrainingOne:require(`../assets/images/services/gaitTraining/gaitTraining-1.jpg`),
    gaittrainingTwo:require(`../assets/images/services/gaitTraining/gaitTraining-2.jpg`),
    headaches:require(`../assets/images/services/headaches/headaches.jpg`),
    headachesOne:require(`../assets/images/services/headaches/headache-1.jpg`),
    headachesTwo:require(`../assets/images/services/headaches/headache-2.jpg`),
    neckPain:require(`../assets/images/services/neckPain/neckPain.jpg`),
    neckPainOne:require(`../assets/images/services/neckPain/neckPain-1.jpg`),
    neckPainTwo:require(`../assets/images/services/neckPain/neckPain-2.jpg`),
    accident:require(`../assets/images/services/accidents/accident.jpg`),
    accidentOne:require(`../assets/images/services/accidents/accident-1.jpg`),
    accidentTwo:require(`../assets/images/services/accidents/accident-2.jpg`),
   wsib:require(`../assets/images/services/wsib/wsib.jpg`),
   wsibOne:require(`../assets/images/services/wsib/wsib-1.jpg`),
   wsibTwo:require(`../assets/images/services/wsib/wsib-2.jpg`),   
   pelvicFloor:require(`../assets/images/services/pelvicFloor/pelvicfloor.jpg`),
   pelvicFloorOne:require(`../assets/images/services/pelvicFloor/pelvicfloorOne.jpg`),
   pelvicFloorTwo:require(`../assets/images/services/pelvicFloor/pelvicfloorThree.jpg`),
}


export const specImages = {
    physiotherapy:require(`../assets/images/specs/physiotherapy/physiotherapy.jpg`),
    physiotherapyOne:require(`../assets/images/specs/physiotherapy/physiotherapy-1.jpg`),
    physiotherapyTwo:require(`../assets/images/specs/physiotherapy/physiotherapy-2.jpg`),
    chiropractic:require(`../assets/images/specs/chiropractic/chiropractic.jpg`),
    chiropracticOne:require(`../assets/images/specs/chiropractic/chiropractic-1.jpg`),
    chiropracticTwo:require(`../assets/images/specs/chiropractic/chiropractic-2.jpg`),
    balanceTraining:require(`../assets/images/specs/balanceTraining/balanceTraining.jpg`),
    balanceTrainingOne:require(`../assets/images/specs/balanceTraining/balanceTraining-1.jpg`),
    balanceTrainingTwo:require(`../assets/images/specs/balanceTraining/balanceTraining-2.jpg`),
    gaitTraining:require(`../assets/images/specs/gaitTraining/gaitTraining.jpg`),
    gaitTrainingOne:require(`../assets/images/specs/gaitTraining/gaitTraining-1.jpg`),
    gaitTrainingTwo:require(`../assets/images/specs/gaitTraining/gaitTraining-2.jpg`),
    preRehab:require(`../assets/images/specs/preRehab/pre-rehab.jpg`),
    preRehabOne:require(`../assets/images/specs/preRehab/preRehab-1.jpg`),
    preRehabTwo:require(`../assets/images/specs/preRehab/preRehab-2.jpg`),
    postRehab:require(`../assets/images/specs/postRejab/postRehab.jpg`),
    postRehabOne:require(`../assets/images/specs/postRejab/postRehab-1.jpg`),
    postRehabTwo:require(`../assets/images/specs/postRejab/postRehab-2.jpg`),
    tmj:require(`../assets/images/specs/tmj/tmj.jpg`),
    tmjOne:require(`../assets/images/specs/tmj/tmj-1.jpg`),
    tmjTwo:require(`../assets/images/specs/tmj/tmj-2.jpg`),
    vestibular:require(`../assets/images/specs/vestabular/vestibular.jpg`),
    vestibularOne:require(`../assets/images/specs/vestabular/vestabularTherapy-1.jpg`),
    vestibularTwo:require(`../assets/images/specs/vestabular/vestabularTherapy-2.jpg`),

  shockwave:require(`../assets/images/specs/shockwave/shockwave.jpg`),
  shockwaveOne:require(`../assets/images/specs/shockwave/shockwaveOne.jpg`),
  shockwaveTwo:require(`../assets/images/specs/shockwave/shockwaveTwo.jpg`),
 taping:require(`../assets/images/specs/taping/taping.jpg`),
 tapingOne:require(`../assets/images/specs/taping/tapingOne.jpg`),
 tapingTwo:require(`../assets/images/specs/taping/tapingTwo.jpg`)

}


export const insuranceLogo =
{
    equitableLogo:require("../assets/images/logo/equitable_logo.png")
}

export const emailContact = "info@conklinphysiochiroplus.com"
export const clinicLocation = "https://maps.app.goo.gl/jSBaVrgq23AxpaN86"
export const mapLocation = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2912.5287560841084!2d-80.29684028772175!3d43.11441737101237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c691fde50e1c3%3A0x4651488972e169d4!2sConklin%20Medical%20Centre!5e0!3m2!1sen!2sca!4v1726888481715!5m2!1sen!2sca" 
export const reviewPage = "https://www.google.com/search?gs_ssp=eJwFwbsNgCAQANDYmjiDNNZwCgiO4BKGHOcX0RAK3N736oZvHCDrEs5h2UU1daIY06O2sHpSggCHSRSpFUhj7NgTaOvl3OITr3BEdpM_0AWGFHMi9u4u3Q6_H0FrGr8&q=conklin+medical+centre+pharmacy&oq=conkli&gs_lcrp=EgZjaHJvbWUqFQgBEC4YJxivARjHARiABBiKBRiOBTIPCAAQIxgnGOMCGIAEGIoFMhUIARAuGCcYrwEYxwEYgAQYigUYjgUyBggCEEUYOTINCAMQLhiDARixAxiABDINCAQQLhiDARixAxiABDIGCAUQRRg8MgYIBhBFGDwyBggHEEUYPNIBCDI5MzJqMGo3qAIAsAIA&sourceid=chrome&ie=UTF-8#lrd=0x882c691fde50e1c3:0x4651488972e169d4,1,,,,"